import React from "react";

const PageNotFound = ({ onGoHome, onGoBack }) => {
  return (
    <div className="not-found-container">
      <div className="not-found-glass-card">
        <div className="error-text-content">
          <h1>Stranica ne postoji</h1>
          <p>
            Stranica koju tražite je premještena, obrisana ili nikada nije ni
            postojala.
          </p>
        </div>

        <div className="error-actions-grid">
          <button className="btn-secondary-glass" onClick={onGoBack}>
            <i className="fa-solid fa-arrow-left"></i> Prethodna stranica
          </button>

          <button className="btn-primary-neon" onClick={onGoHome}>
            <i className="fa-solid fa-house"></i> Vrati se na početnu
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
